var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l1 = _vm.__map(_vm.dataList, function(t, key) {
    var l0 = _vm.__map(t, function(item, index) {
      var m0 = _vm.$getImg(item.cover)
      return {
        $orig: _vm.__get_orig(item),
        m0: m0
      }
    })

    return {
      $orig: _vm.__get_orig(t),
      l0: l0
    }
  })

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l1: l1
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }